import { useEffect, useMemo } from 'react';

import { MC_EVENTS } from '@pkg/hooks';

import { apiFactory, type SupportedTokens, type YacsMultichainEventTypes, YacsTopicKey } from '@app/client';
import { type YacsEventData } from '@app/client/common/structs';

interface MultichainWSProps {
    eventType: YacsMultichainEventTypes;
    chain: SupportedTokens;
    onEvent: (eventData: YacsEventData) => void;
    disabled?: boolean;
}
export function useMultichainWS({ eventType, chain, onEvent, disabled = false }: MultichainWSProps) {
    const yacsWsConnection = useMemo(() => {
        if (disabled) return;
        const connection = apiFactory().websocketConnections.yacs.connection;
        return connection?.on('connect', () => {
            return connection;
        });
    }, [disabled]);

    useEffect(() => {
        if (disabled) return;
        const subscription = eventType ? MC_EVENTS[eventType] : undefined;
        const topicName = `${subscription?.emitter.name}.${chain}.*`; // todo update to accept contract

        if (subscription && yacsWsConnection) {
            yacsWsConnection?.emit(YacsTopicKey.subscribe, topicName);
            yacsWsConnection?.on(subscription.listener, async (data) => {
                const eventData = data as YacsEventData;
                if (eventData) {
                    onEvent(eventData);
                }
            });
        }

        return () => {
            yacsWsConnection?.emit(YacsTopicKey.unsubscribe, topicName);
            yacsWsConnection?.off();
        };
    }, [chain, disabled, eventType, onEvent, yacsWsConnection]);
}
